import { useMutation } from "@tanstack/react-query";
import { resendVerificationCode } from "../requests/resend-code.ts";
import type { ResendVerificationCodeRequest } from "../../types.ts";

// Mutation hook for resending verification code
export const useResendCodeMutation = () => {
  return useMutation({
    mutationFn: async (data: ResendVerificationCodeRequest) => {
      const response = await resendVerificationCode(data);
      return response.data;
    },
  });
};
